import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import {ConfirmAction} from "@/components/ConfirmAction.jsx";

export function DeleteAction({ id, type='icon', name, redirectOnSuccess, redirectTo = '..', useDelete, errorOverrides }) {
  return <ConfirmAction
    id={id}
    type={type}
    name={name}
    useAction={useDelete}
    redirectOnSuccess={redirectOnSuccess}
    redirectTo={redirectTo}
    icon={<DeleteOutlineRoundedIcon />}
    actionColor="danger"
    texts={{
      tooltip: 'Delete',
      title: `Delete ${name}?`,
      message: `Are you sure you want to delete ${name}?`,
      action: 'Delete',
    }}
    errorOverrides={errorOverrides || {
      409: "The resource cannot be deleted, since it's currently in use."
    }}
  />;
}
